@if (previewService.preview()) {
  <div class="preview" (click)="previewService.deletePreview()">
    <img class="preview__image" [src]="previewService.preview()?.url" />
  </div>
}
